import type { AdvisoryAiOrgReportRow } from '@/features/advisory-ai/types'
import { CallCard } from './CallCard'

type CallStatusSectionProps = {
  title: string
  dotColor: string
  calls: AdvisoryAiOrgReportRow[]
  orgId: string
  isRefreshing: boolean
  isDeleting: boolean
  onRefresh: () => void
  onDelete: (row: AdvisoryAiOrgReportRow) => void
  onRefreshToast: () => void
  onBlocked: () => void
}

export function CallStatusSection({
  title,
  dotColor,
  calls,
  orgId,
  isRefreshing,
  isDeleting,
  onRefresh,
  onDelete,
  onRefreshToast,
  onBlocked,
}: CallStatusSectionProps) {
  if (calls.length === 0) return null

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-4">
        <div className={`w-3 h-3 rounded-full ${dotColor}`} />
        <h2 className="text-lg font-semibold text-gray-900">
          {title} {calls.length}
        </h2>
      </div>
      {calls.map((call) => (
        <div key={call.advisoryCallId}>
          <CallCard
            row={call}
            orgId={orgId}
            isRefreshing={isRefreshing}
            isDeleting={isDeleting}
            onRefresh={onRefresh}
            onDelete={onDelete}
            onRefreshToast={onRefreshToast}
            onBlocked={onBlocked}
          />
        </div>
      ))}
    </div>
  )
}
